import { render, staticRenderFns } from "./GoodsClass.vue?vue&type=template&id=25a3e8bd"
import script from "./GoodsClass.vue?vue&type=script&lang=js"
export * from "./GoodsClass.vue?vue&type=script&lang=js"
import style0 from "./GoodsClass.vue?vue&type=style&index=0&id=25a3e8bd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports